import { render, staticRenderFns } from "./branding.vue?vue&type=template&id=449449fa&scoped=true&"
import script from "./branding.vue?vue&type=script&lang=js&"
export * from "./branding.vue?vue&type=script&lang=js&"
import style0 from "./branding.vue?vue&type=style&index=0&id=449449fa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449449fa",
  null
  
)

export default component.exports